"use client";
import React, { useState } from "react";
import Link from "components/common/Link";
import Layout from "./Layout";
import Rail from "./Rail";
import { BookingQRModal } from "components/common";
import OfferDetailModal from "components/home/OfferDetailModal";
import OfferCard from "components/home/Card/OfferCard";
import { map, get, compact } from "utils/lodash";
import { useT, useI18n } from "providers/I18nProvider";
import useRotatingTagline from "hooks/useRotatingTagline";

export const OFFER_LIST_PATH = "/uu-dai";

const SectionExperienceOffer: React.FC<{
  title?: string;
  description?: string;
  items?: any[];
}> = ({ title, description, items }) => {
  const t = useT();
  const { locale } = useI18n();
  // Câu giới thiệu tự đổi mỗi 2 phút (4 biến thể trong file dịch)
  const rotatingDesc = useRotatingTagline("home.experienceOfferDesc", description);
  const [selected, setSelected] = useState<any>(null); // gói đang xem chi tiết
  const [qrOpen, setQrOpen] = useState(false);

  // Mỗi item là 1 gói ưu đãi (campaignPackage) chứa dịch vụ của shop
  const packages = compact(
    map(items, (item) => get(item, "campaignPackage")),
  ).filter((pkg) => !!pkg?.id);

  if (!packages.length) return null;

  return (
    <>
      <Layout
        iconName="sun-fog"
        title={locale === "en" ? t("home.experienceOffer") : title || t("home.experienceOffer")}
        description={rotatingDesc}
        // Nền blend nhẹ: teal pastel trên → trắng dưới, tách khỏi section trắng kề bên
        className="bg-gradient-to-b from-[#eefbfb] via-[#f7fdfd] to-white"
        extra={
          <Link
            href={OFFER_LIST_PATH}
            className="tap-area inline-flex min-h-6 items-center text-sm font-bold text-primary-ink hover:underline"
          >
            {t("home.viewAll")} →
          </Link>
        }
      >
        <Rail className="gap-3 md:gap-4 px-4 md:px-6">
          {packages.map((pkg, idx) => (
            <OfferCard key={get(pkg, "id") || idx} pkg={pkg} onClick={setSelected} />
          ))}

          {/* Card cuối dải: nhảy sang trang listing toàn bộ ưu đãi */}
          <Link
            href={OFFER_LIST_PATH}
            className="group w-[110px] md:w-[200px] flex-shrink-0 rounded-2xl border-2 border-dashed border-primary/40 bg-[#eefbfb] flex flex-col items-center justify-center gap-2 md:gap-3 text-center p-3 md:p-5 transition-all duration-300 hover:-translate-y-1 hover:bg-[#dff6f5] hover:border-primary"
          >
            <span className="w-9 h-9 md:w-14 md:h-14 rounded-full bg-white text-primary shadow flex items-center justify-center text-lg md:text-2xl font-bold transition-transform group-hover:translate-x-1">
              →
            </span>
            <span className="font-bold text-black01 leading-snug text-[12px] md:text-base">
              {t("home.seeMoreOffers")}
            </span>
            <span className="hidden md:block text-xs text-gray-500">{t("home.seeMoreOffersHint")}</span>
          </Link>
        </Rail>
      </Layout>

      {/* Bước 1: chi tiết ưu đãi + dịch vụ */}
      <OfferDetailModal
        open={!!selected}
        pkg={selected}
        onClose={() => setSelected(null)}
        onBook={() => {
          setSelected(null);
          setQrOpen(true);
        }}
      />

      {/* Bước 2: đặt lịch -> popup QR tải app */}
      <BookingQRModal open={qrOpen} onClose={() => setQrOpen(false)} />
    </>
  );
};

export default SectionExperienceOffer;
